// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__15THP","header":"ReportDetails_header__2H5gh","title":"ReportDetails_title__ds-Sd","left":"ReportDetails_left__3NedH"};